<template>
  <!-- Top Navigation -->
  <div class="hidden-sm-and-down">
    <div v-if="isOnline">
      <v-system-bar dark>
        <img src="@/assets/icon-flag.png"  width="30" />
        <v-subheader><b style="color: white;">Zam</b></v-subheader>
        <v-subheader>
          <div class="locale-changer" style="color: white;">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <b>
                    <select v-model="$i18n.locale" style="background-color: black">
                      <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ lang }}</option>
                    </select>
                    <v-icon style="color: white;">mdi-chevron-down</v-icon>
                  </b>
                </span>
              </template>
              <span>{{$t('navigation_language')}}</span>
            </v-tooltip>
          </div>
        </v-subheader>
        <v-subheader><b style="color: white;">{{ $t('languages_choosen')}}</b></v-subheader>
        <v-subheader><b style="color: white;">+26097XXXXX70</b></v-subheader>
        <v-subheader><b style="color: white;">Convergeozambia@gmail.com</b></v-subheader>
        <v-spacer></v-spacer>
        <a href="https://facebook.com">
          <v-icon>mdi-facebook-box mdi-24px</v-icon>
        </a>
        <a href="https://twitter.com">
          <v-icon>mdi-twitter-box mdi-24px</v-icon>
        </a>
        <a href="https://instagram.com">
          <v-icon>mdi-instagram mdi-24px</v-icon>
        </a>
        <a href="https://gmail.com">
          <v-icon>mdi-gmail mdi-24px</v-icon>
        </a>
      </v-system-bar>
    </div>
    <div v-if="isOffline">
      <v-system-bar dark color="grey darken-3">
        <img src="@/assets/icon-flag.png"  width="30" />
        <v-subheader><b style="color: white;">Zam</b></v-subheader>
        <v-subheader><b style="color: white;">+26097XXXXX70</b></v-subheader>
        <v-subheader><b style="color: white;">Convergeozambia@gmail.com</b></v-subheader>
        <v-spacer></v-spacer>
        <v-subheader><b style="color: white;">{{ $t('common_offline_text') }}</b></v-subheader>
      </v-system-bar>
    </div>
  </div>
</template>

<script>
	export default {
    name: 'locale-changer',
    data () {
      return { langs: ['en','nj','fr','ru','ch'] }
    }
	}
</script>
